export interface GeoPoint {
  lat: number;
  lng: number;
}

export const locationData = {
  settlement: {
    lat: 59.83694,
    lng: 29.859702,
  },
  entrance: {
    lat: 59.839875,
    lng: 29.863231,
  },
  mapLink: 'https://yandex.ru/maps/-/CTC5VCjT',
  directions: [
    { time: '5–7 минут', destination: 'до выезда на КАД' },
    { time: '10–12 минут', destination: 'до станции Новый Петергоф' },
    { time: '15–20 минут', destination: 'до парков и дворцов Петергофа' },
  ],
  infrastructure: [
    'Школа',
    'Детский сад',
    'Магазины',
    'Пункты выдачи заказов',
    'Амбулатория',
    'Остановки общественного транспорта',
  ],
  publicTransportRoutes: ['360', '653', '639Б'],
} as const;

function formatPoint(point: GeoPoint) {
  return `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`;
}

export const yandexMapEmbedUrl = `https://yandex.ru/map-widget/v1/?ll=${locationData.settlement.lng.toFixed(6)}%2C${locationData.settlement.lat.toFixed(6)}&z=14&pt=${locationData.settlement.lng.toFixed(6)}%2C${locationData.settlement.lat.toFixed(6)}%2Cpm2rdm`;

export const yandexEntranceRouteUrl = `https://yandex.ru/maps/?mode=routes&rtext=~${encodeURIComponent(formatPoint(locationData.entrance))}&rtt=auto`;
